export default {
  tryAgain: "Erneut versuchen",
  goHome: "Zur Startseite",
  loading: "Wird geladen…",
  send: "Senden",
  save: "Speichern",
  cancel: "Abbrechen",
  delete: "Löschen",
  optional: "Optional",
  edit: "Bearbeiten",
  back: "Zurück",
  refresh: "Aktualisieren",
  confirm: "Bestätigen",
  close: "Schließen",
  add: "Hinzufügen",
  copied: "Kopiert",
  clickToCopy: "Zum Kopieren klicken",
  clickToCopyValue: "{{value}} kopieren",
  copyFailed: "Kopieren in die Zwischenablage fehlgeschlagen",
  search: "Suchen",
  clearSearch: "Suche löschen",
  quickSearch: {
    title: "Schnellsuche",
    placeholder: "Zu einer Seite gehen…",
    empty: "Keine passenden Seiten",
    hint: "↑↓ navigieren · Enter öffnen · Esc schließen",
  },
  inactive: "Inaktiv",
  user: "Benutzer",
  privacyPolicy: "Datenschutzerklärung",
  cookiePolicy: "Cookie-Richtlinie",
  cookiePreferences: "Cookie-Einstellungen",
  privacyAndCookies: "Datenschutz und Cookies",
  privacyPolicyOpening: "Datenschutzerklärung wird geöffnet…",
  backToDashboard: "Zurück zum Dashboard",
  backToLogin: "Zurück zur Anmeldung",
  copyright: "© {{year}} Flitrip. Alle Rechte vorbehalten.",
  language: {
    label: "Sprache",
  },
  greeting: {
    morning: "Guten Morgen",
    afternoon: "Guten Tag",
    evening: "Guten Abend",
  },
  errorOccurred: "Ein Fehler ist aufgetreten",
  somethingWentWrong:
    "Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.",
  appCrashTitle: "Etwas ist schiefgelaufen",
  appCrashMessage:
    "Versuchen Sie es erneut, um den Bildschirm neu zu laden, ohne die App zu verlassen. Wenn es weiterhin fehlschlägt, aktualisieren Sie den Browser oder gehen Sie zur Startseite.",
  relative: {
    justNow: "Gerade eben",
    minutesAgo: "vor {{count}} Min.",
    hoursAgo: "vor {{count}} Std.",
    daysAgo: "vor {{count}} T.",
  },
  chat: {
    dayToday: "Heute",
    dayYesterday: "Gestern",
  },
  fileSize: {
    bytes: "{{count}} B",
    kb: "{{size}} KB",
    mb: "{{size}} MB",
  },
  unsavedChanges: {
    navigationTitle: "Ungespeicherte Änderungen",
    navigationMessage:
      "Speichern oder setzen Sie Ihre Änderungen zurück, bevor Sie diese Seite verlassen.",
  },
  sectionModified: "Geändert",
  saveBar: {
    unsaved: "Ungespeicherte Änderungen",
    allSaved: "Alles gespeichert",
    save: "Änderungen speichern",
    saveDraft: "Entwurf speichern",
    revert: "Änderungen zurücksetzen",
    revertConfirmTitle: "Ungespeicherte Änderungen verwerfen?",
    revertConfirmMessage:
      "Ihre Bearbeitungen gehen verloren. Dies kann nicht rückgängig gemacht werden.",
    revertConfirm: "Änderungen verwerfen",
  },
  addressAutocomplete: {
    loading: "Adressen werden gesucht…",
    error: "Adressvorschläge konnten nicht geladen werden.",
    noStreetResults:
      "Keine Straßenadressen gefunden. Tippen Sie weiter oder wählen Sie eine vollständige Adresse aus der Liste.",
  },
  addressSearch: {
    label: "Adresse",
    placeholder: "Tippen Sie, um nach einer Adresse zu suchen…",
    editDetails: "Adressdetails bearbeiten",
    detailFieldsError: "Prüfen Sie die Adressdetails unten.",
    fieldRequired: "Dieses Feld ist erforderlich.",
  },
  addressValidation: {
    checking: "Adresse wird geprüft…",
    valid: "Adresse ist gültig",
    invalid:
      "Diese Adresse konnte nicht gefunden werden. Prüfen Sie die Angaben oder wählen Sie eine andere Adresse.",
    incomplete:
      "Füllen Sie alle Adressfelder aus, um den Standort zu validieren.",
    saveConfirmTitle: "Ungültige Adresse",
    saveConfirmButton: "Trotzdem speichern",
    saveWarningActivity:
      "Diese Adresse ist ungültig. Kunden sehen diese Aktivität in der App möglicherweise nicht, da ein geokodierter Standort erforderlich ist.",
    saveWarningHouse:
      "Diese Adresse ist ungültig und wird möglicherweise nicht korrekt geokodiert. Standortdienste für diese Struktur funktionieren möglicherweise nicht.",
  },
  editableLocation: {
    noCoordinatesWarning:
      "Wählen Sie eine Adresse aus der Liste, geben Sie eine erkennbare Adresse ein oder klicken Sie auf die Karte, um den Standort festzulegen.",
    mapHint:
      "Ziehen Sie den Marker oder klicken Sie auf die Karte, um den Standort anzupassen.",
    mapUnavailable:
      "Kartenvorschau nicht verfügbar (Karte nicht konfiguriert).",
    mapAriaLabel: "Bearbeitbare Standortkarte",
  },
  map: {
    expand: "Vergrößern",
    expandedTitle: "Karte",
    zoomHintCtrl: "Strg + Scrollen zum Zoomen der Karte",
    zoomHintCmd: "⌘ + Scrollen zum Zoomen der Karte",
    panHintTouch: "Mit zwei Fingern die Karte verschieben",
  },
  environmentBanner: {
    message:
      "Sie befinden sich in der {{environment}}-Umgebung. Dies ist nicht die Produktion — Daten und Zahlungen dienen nur zu Testzwecken.",
    messageShort: "Sie sind in {{environment}}",
    productionMessage:
      "Sie befinden sich in der Produktion. Sie verwenden Live-Daten und echte Zahlungsabwicklung — gehen Sie vorsichtig vor.",
    productionMessageShort: "Sie sind in der Produktion",
    envNames: {
      development: "Entwicklung",
      staging: "Staging",
    },
    shortEnvNames: {
      development: "Entwicklung",
      staging: "Staging",
    },
  },
  region: {
    label: "Zahlungsregion",
    empty: "Keine Regionen verfügbar",
    filterAll: "Alle Regionen",
    filterLabel: "Region",
    colCode: "Region",
    unknown: "—",
    names: {
      IT: "Italien",
      ES: "Spanien",
    },
  },
  table: {
    paginationSummary: "{{start}}–{{end}} von {{total}}",
    rowsPerPage: "Zeilen pro Seite",
    previousPage: "Zurück",
    nextPage: "Weiter",
    pageOf: "Seite {{page}} von {{totalPages}}",
    resizeColumn: "Spalte vergrößern/verkleinern",
    resizeColumnFor: "Spalte {{column}} vergrößern/verkleinern",
    preferencesOpen: "Einstellungen",
    preferencesTitle: "Tabelleneinstellungen",
    preferencesDescription:
      "Wählen Sie, wie viele Zeilen angezeigt werden und welche Spalten sichtbar sind.",
    preferencesPageSize: "Zeilen pro Seite",
    preferencesColumns: "Spalten",
    preferencesColumnsHint:
      "Ziehen zum Sortieren. Abwählen, um eine Spalte auszublenden.",
    preferencesConfirm: "Bestätigen",
    preferencesCancel: "Abbrechen",
    preferencesReset: "Auf Standard zurücksetzen",
    reorderColumn: "Spalte neu anordnen",
    selectRow: "Zeile auswählen",
    selectionColumn: "Auswahl",
    selectionHint: "Wählen Sie Zeilen über die Kontrollkästchen links aus.",
    selectedCount: "{{count}} ausgewählt",
    selectAllOnPage: "Alle auf dieser Seite auswählen",
    clearSelection: "Auswahl aufheben",
  },
} as const;
